(function () {
  if (window.MaWish) return;

  var KEY = 'ma:wishlist';
  var ROOT = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(parsed)) return [];
      return parsed.filter(function (handle) {
        return typeof handle === 'string' && handle.length > 0;
      });
    } catch (error) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (error) {
      list = list.slice();
    }
    document.dispatchEvent(new CustomEvent('ma:wishlist:change', { detail: { items: list } }));
  }

  var MaWish = {
    all: function () {
      return read();
    },
    has: function (handle) {
      return read().indexOf(handle) > -1;
    },
    add: function (handle) {
      var list = read();
      if (list.indexOf(handle) === -1) {
        list.unshift(handle);
        write(list);
      }
      return list;
    },
    remove: function (handle) {
      var list = read().filter(function (item) {
        return item !== handle;
      });
      write(list);
      return list;
    },
    toggle: function (handle) {
      return MaWish.has(handle) ? (MaWish.remove(handle), false) : (MaWish.add(handle), true);
    },
    clear: function () {
      write([]);
    }
  };

  window.MaWish = MaWish;

  function sync() {
    var list = read();

    document.querySelectorAll('[data-wish][data-handle]').forEach(function (button) {
      var on = list.indexOf(button.getAttribute('data-handle')) > -1;
      button.classList.toggle('is-on', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
      var labelOn = button.getAttribute('data-label-on');
      var labelOff = button.getAttribute('data-label-off');
      if (labelOn && labelOff) {
        button.setAttribute('aria-label', on ? labelOn : labelOff);
        var text = button.querySelector('[data-wish-label]');
        if (text) text.textContent = on ? labelOn : labelOff;
      }
    });

    document.querySelectorAll('[data-wish-count]').forEach(function (el) {
      el.textContent = list.length;
    });

    document.querySelectorAll('[data-wish-badge]').forEach(function (el) {
      el.classList.toggle('is-shown', list.length > 0);
      el.hidden = list.length === 0;
    });
  }

  function heartSvg() {
    return '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><path d="M10 16.5c-.3 0-.6-.1-.8-.3C6 13.4 3 11 3 7.9A3.9 3.9 0 0 1 6.9 4c1.3 0 2.4.6 3.1 1.6A3.8 3.8 0 0 1 13.1 4 3.9 3.9 0 0 1 17 7.9c0 3.1-3 5.5-6.2 8.3-.2.2-.5.3-.8.3Z" stroke="currentColor" stroke-width="1.25" stroke-linejoin="round"/></svg>';
  }

  function mountHeaderLink() {
    var icons = document.querySelector('.header__icons');
    if (!icons || icons.querySelector('[data-wish-link]')) return;

    var link = document.createElement('a');
    link.className = 'header__icon link focus-inset ma-wishLink';
    link.href = ROOT + 'pages/wishlist';
    link.setAttribute('data-wish-link', '');
    link.setAttribute('aria-label', 'Saved');
    link.innerHTML =
      heartSvg() +
      '<div class="cart-count-bubble ma-wishLink__count" data-wish-badge hidden>' +
      '<span aria-hidden="true" data-wish-count>0</span>' +
      '<span class="visually-hidden">saved</span>' +
      '</div>';

    var cart = icons.querySelector('#cart-icon-bubble') || icons.querySelector('.header__icon--cart');
    if (cart && cart.parentNode === icons) {
      icons.insertBefore(link, cart);
    } else {
      icons.appendChild(link);
    }
  }

  function swapSection(targetSelector, html, sourceSelector) {
    var target = document.querySelector(targetSelector);
    if (!target) return;
    var source;
    try {
      source = new DOMParser().parseFromString(html, 'text/html').querySelector(sourceSelector);
    } catch (error) {
      return;
    }
    if (source) target.innerHTML = source.innerHTML;
  }

  function setAddLabel(button, key) {
    var label = button.querySelector('[data-wish-add-label]');
    var value = button.getAttribute('data-label-' + key);
    if (label && value) label.textContent = value;
  }

  function addAll(button) {
    var items = [];

    document.querySelectorAll('[data-wish-tile]').forEach(function (tile) {
      var add = tile.querySelector('[data-card-add]');
      if (add && add.disabled) return;
      var input = tile.querySelector('input[name="id"]');
      if (input && input.value) items.push({ id: input.value, quantity: 1 });
    });

    if (items.length === 0) return;

    button.classList.add('is-busy');
    setAddLabel(button, 'busy');

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: 'cart-icon-bubble,cart-drawer',
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data && data.sections) {
          if (data.sections['cart-icon-bubble']) {
            swapSection('#cart-icon-bubble', data.sections['cart-icon-bubble'], '#shopify-section-cart-icon-bubble');
          }
          if (data.sections['cart-drawer']) {
            swapSection('cart-drawer', data.sections['cart-drawer'], '#shopify-section-cart-drawer cart-drawer');
          }
        }
        setAddLabel(button, 'done');
        setTimeout(function () {
          setAddLabel(button, 'idle');
        }, 2600);
      })
      .catch(function () {
        setAddLabel(button, 'idle');
      })
      .finally(function () {
        button.classList.remove('is-busy');
      });
  }

  document.addEventListener('click', function (event) {
    var addEvery = event.target.closest('[data-wish-add-all]');
    if (addEvery) {
      event.preventDefault();
      addAll(addEvery);
      return;
    }

    var button = event.target.closest('[data-wish][data-handle]');
    if (button) {
      event.preventDefault();
      MaWish.toggle(button.getAttribute('data-handle'));
      button.classList.add('is-beat');
      setTimeout(function () {
        button.classList.remove('is-beat');
      }, 500);
      return;
    }

    var clear = event.target.closest('[data-wish-clear]');
    if (clear) {
      event.preventDefault();
      MaWish.clear();
    }
  });

  document.addEventListener('ma:wishlist:change', sync);

  window.addEventListener('storage', function (event) {
    if (event.key === KEY) {
      sync();
      document.querySelectorAll('ma-wishlist').forEach(function (el) {
        if (el.reconcile) el.reconcile();
      });
    }
  });

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      sync();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  class MaWishlist extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-wish-grid]');
      this.blank = this.querySelector('[data-wish-empty]');
      this.busy = this.querySelector('[data-wish-loading]');
      this.actions = this.querySelector('[data-wish-actions]');
      this.pending = {};
      this.reconcile = this.reconcile.bind(this);
      document.addEventListener('ma:wishlist:change', this.reconcile);
      this.reconcile();
    }

    disconnectedCallback() {
      document.removeEventListener('ma:wishlist:change', this.reconcile);
    }

    reconcile() {
      if (!this.grid) return;
      var list = MaWish.all();
      var self = this;

      Array.prototype.slice.call(this.grid.children).forEach(function (tile) {
        if (list.indexOf(tile.getAttribute('data-wish-tile')) === -1) tile.remove();
      });

      var missing = list.filter(function (handle) {
        return !self.grid.querySelector('[data-wish-tile="' + handle + '"]') && !self.pending[handle];
      });

      if (missing.length === 0) {
        this.settle(list);
        return;
      }

      missing.forEach(function (handle) {
        self.pending[handle] = true;
      });

      if (this.busy) this.busy.hidden = false;

      Promise.all(
        missing.map(function (handle) {
          return fetch(ROOT + 'products/' + handle + '?section_id=ma-wish-card')
            .then(function (response) {
              return response.ok ? response.text() : '';
            })
            .then(function (html) {
              return { handle: handle, html: html };
            })
            .catch(function () {
              return { handle: handle, html: '' };
            });
        })
      ).then(function (results) {
        var gone = [];

        results.forEach(function (result) {
          delete self.pending[result.handle];

          var card = result.html
            ? new DOMParser().parseFromString(result.html, 'text/html').querySelector('.ma-card')
            : null;

          if (!card) {
            gone.push(result.handle);
            return;
          }

          if (self.grid.querySelector('[data-wish-tile="' + result.handle + '"]')) return;
          if (MaWish.all().indexOf(result.handle) === -1) return;

          var tile = document.createElement('li');
          tile.className = 'ma-wish__tile';
          tile.setAttribute('data-wish-tile', result.handle);
          tile.appendChild(card);
          self.grid.appendChild(tile);
        });

        if (self.busy) self.busy.hidden = true;
        gone.forEach(function (handle) {
          MaWish.remove(handle);
        });
        self.order();
        self.settle(MaWish.all());
      });
    }

    order() {
      var list = MaWish.all();
      var self = this;
      list.forEach(function (handle) {
        var tile = self.grid.querySelector('[data-wish-tile="' + handle + '"]');
        if (tile) self.grid.appendChild(tile);
      });
    }

    settle(list) {
      var empty = list.length === 0;
      if (this.blank) this.blank.hidden = !empty;
      if (this.grid) this.grid.hidden = empty;
      if (this.actions) this.actions.hidden = empty;
      this.classList.toggle('is-empty', empty);
    }
  }

  if (!window.customElements.get('ma-wishlist')) {
    window.customElements.define('ma-wishlist', MaWishlist);
  }

  function start() {
    mountHeaderLink();
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
